import axios from 'axios'
import {Message, Loading} from 'element-ui'
import router from '@/router'
import {encode} from '@/util/Base64'
import qs from 'qs'
import {exportFile} from './exportFile'
import store from '@/store'
import Cookies from "js-cookie";
// export const baseURL1 = 'http://192.168.0.111:8090/'
// export const baseURL1 = 'https://fawutest.infore.com/'
export const baseURL1 = 'https://ils.infore.com/'
export const baseURL = process.env.VUE_APP_BASE_API
// export const weosocketUrl = 'wss://fawutest.infore.com/websocket/'
export const weosocketUrl = 'wss://ils.infore.com/websocket/'
// export const weosocketUrl = 'ws://192.168.1.179:8090/websocket/'
// export const baseURL = 'http://192.168.0.111:8090' // 王帅
// export const baseURL = 'http://192.168.0.124:8090'  // laochu
// export const baseURL = 'https://fawutest.infore.com/yingfen'  // laochu
// export const baseURL = 'http://localhost:8090'
/**
 * @author LiuMing
 * 网络请求封装
 */
const service = axios.create({
    baseURL,
    // 超时时间
    timeout: 300000000,
})
let loadingInstance
/**
 * 请求拦截
 */
service.interceptors.request.use((config) => {


    // 从vuex中拿到token,添加请求头中
    if (store.getters.token) {
        config.headers.token = encode( store.getters.token )// 获取token
        config.headers.resourceToken = store.state.user.resourceToken //  法律资源token
        if (config.headers.LOADING && store.state.user.haveNumber != 1) {
            loadingInstance = Loading.service()
        }
    } else {
        // window.location.href = 'http://192.168.1.241:8000/home/hello?url=http://localhost:8090/success'
    }
    return config
})

/**
 * 返回拦截
 */
service.interceptors.response.use(async (response) => {
        if (loadingInstance) loadingInstance.close();
        if (response.data instanceof Blob) {
            return response
        }
        // 获取接口返回结果
        const res = response.data;
        if(res) {
            // 判断code 码
            switch (res.code) {
                // 1为成功, 返回所有数据与token
                case 200: {
                    return res
                }
                // -1未登录状态码
                case 701: {
                    setTimeout(() => {
                        sessionStorage.clear();
                        Cookies.remove('SIAMTGT');
                        // let url = encodeURIComponent('https://fawutest.infore.com/#/wel/index')
                        // window.location.href = `https://siamtest.infore.com/siam/oauth2.0/authorize?client_id=AUTH_FWHG1&redirect_uri=${url}&response_type=code`
                        let url = encodeURIComponent('https://ils.infore.com/#/wel/index')
                        window.location.href = `https://login.infore.com/siam/oauth2.0/authorize?client_id=ils_pc&redirect_uri=${url}&response_type=code`
                    }, 500)
                    break
                }
                //   法律资源-1未登录状态码
                case 702: {
                    Message.error(res.msg || res.message)
                    store.state.user.isCloseTip = false
                    setTimeout(() => {
                        router.push({
                            path: '/resourceManagementLogin/index'
                        })
                    }, 500)
                    break
                }
                //   慧证400无权查看
                case 400: {
                    store.state.user.isCloseTip = false
                    break
                } // 转下一阶
                case 402: {
                    store.state.user.isCloseTip = false
                    return res

                }
                // 其他报错
                default: {
                    Message({
                        message: res.msg || res.message,
                        type: 'warning'
                    });
                    // return res
                    throw new Error(res.msg || res.message)
                }
            }
        } else {
            return res
        }
    },
    error => {
        if (loadingInstance) loadingInstance.close();
        // Message({
        //     message: error.response.data.msg || error.response.data.message || '凭证失效，请重新登录',
        //     type: 'error'
        // });
        Promise.reject(error.response.data)
        throw new Error(error.response?.data)
    }
)

/**
 * get请求
 * @author LiuMing
 * @param {String} url
 * @param {Object} params
 * @param {import('axios').AxiosRequestConfig} config
 * @param {Boolean} LOADING
 * @returns
 */
export function Get(url, params, config, LOADING = true) {
    return service.get(
        url,
        {
            ...config,
            params,
            headers: {
                LOADING
            }
        }
    )
}
/**
 * post请求
 * @author LiuMing
 * @param {String} url
 * @param {Object} data
 * @param {import('axios').AxiosRequestConfig} config
 * @param {Boolean} LOADING
 * @returns
 */
export function Post(url, data, config, LOADING = true) {
    return service.post(
        url,
        data,
        {
            ...config,
            headers: {
                LOADING
            }
        },
    )
}

/**
 * put请求
 * @author LiuMing
 * @param {String} url
 * @param {Object} data
 * @param {AxiosRequestConfig} config
 * @param {Boolean} LOADING
 * @returns
 */
export function Put(url, data, config, LOADING = true) {
    return service.put(
        url,
        data,
        {
            ...config,
            headers: {
                LOADING
            }
        })
}

/**
 * delete请求
 * @author LiuMing
 * @param {String} url
 * @param {Object} params
 * @param {AxiosRequestConfig} config
 * @param {Boolean} LOADING
 * @returns
 */
export function Delete(url, params, config, LOADING = true) {
    return service.delete(
        url,
        {
            ...config,
            params,
            headers: {
                LOADING
            }
        }
    )
}

/**
 * FormData请求
 * @author LiuMing
 * @param {String} url
 * @param {Object} data
 * @param {import('axios').AxiosRequestConfig} config
 * @param {Boolean} LOADING
 * @returns
 */
export function PostForm(url, data, config, LOADING = true) {
    return service.post(
        url,
        qs.stringify(data),
        {
            ...config,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                LOADING
            }
        },
    )
}

/**
 * 上传文件
 * @author LiuMing
 * @param {String} url
 * @param {Object} data
 * @param {String} fileName 文件名
 * @param {import('axios').AxiosRequestConfig} config
 * @param {Boolean} LOADING
 * @returns
 */
export function UploadFile(url, data, config, LOADING = true) {
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
        formData.append(key, data[key])
    })

    return service.post(
        url,
        formData,
        {
            ...config,
            headers: {
                'Content-Type': 'multipart/form-data',
                LOADING
            }
        }
    )
}

/**
 * 下载文件
 * @author LiuMing
 * @param {String} url
 * @param {Object} data
 * @param {AxiosRequestConfig} config
 * @param {String} fileName 文件名称
 * @param {Boolean} LOADING
 * @returns
 */
export function DownloadFile(url, data, fileName, config, LOADING = true) {
    let headers = {}
    if (config && config.headers) {
        headers = {
            ...config.headers,
            LOADING
        }
    } else {
        headers = {
            LOADING
        }
    }
    return service.post(
        url,
        data,
        {
            ...config, responseType: "blob",
            headers
        })
        .then(({data, headers}) => {
            exportFile(data, headers, fileName);
        })
}

/**
 * @author LiuMing
 * 网络请求工具
 */
export default {
    Get,
    Post,
    Put,
    Delete,
    PostForm,
    UploadFile,
    DownloadFile
}
